import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://wtkxurqcssctzihjwaeq.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Ind0a3h1cnFjc3NjdHppaGp3YWVxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU4OTk3MzcsImV4cCI6MjA5MTQ3NTczN30.-2pPdMVgYfhiOLMh54GdJuAZlXNJpjx-am8Tv8kU4r8';

// Singleton pattern to prevent multiple clients
let supabaseInstance = null;

const getSupabaseClient = () => {
    if (supabaseInstance) return supabaseInstance;
    
    supabaseInstance = createClient(supabaseUrl, supabaseKey, {
        auth: {
            persistSession: true,
            autoRefreshToken: true,
            detectSessionInUrl: true,
            flowType: 'implicit',
            storage: window.localStorage,
            storageKey: 'sb-auth-token'
        },
        realtime: {
            params: {
                eventsPerSecond: 10
            }
        },
        global: {
            headers: {
                'X-Client-Info': 'pharma-empower-frontend'
            }
        }
    });
    
    return supabaseInstance;
};

export const supabase = getSupabaseClient();
